var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 107.7 109.7",
    style: {
      enableBackground: "new 0 0 107.7 109.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M82.7,43.7c-3,6.2-7.6,9.8-14.4,9.8c-6.8,0-11.5-3.5-14.5-9.7c-3,6.2-7.8,9.7-14.5,9.7c-6.8-0.1-11.5-3.7-14.4-9.9 c-1.2,2.7-2.8,5-5.1,6.7c-2.3,1.8-4.9,2.7-7.8,3.1v36c0,5.2,0,10.5,0,15.7c0,2.3,1.2,4.1,3.3,4.4c1.8,0.3,3.6,0.1,5.5,0.1V108 c0-12.1,0-24.2,0-36.4c0-4.8,3.2-7.9,8-8c3.9,0,7.8,0,11.8,0c4.6,0,7.8,3.2,7.8,7.8v38.2c0.4,0,0.5,0,0.7,0c13.6,0,27.1,0,40.7,0 c2.8,0,4.7-1.9,4.7-4.8c0-16.8,0-33.7,0-50.5v-1.2C88.8,52,85.1,48.8,82.7,43.7z M85.5,87.5c0,3.3-2.6,5.9-6,5.9 c-2.8,0-5.7,0-8.5,0c-2.8,0-5.6,0-8.4,0c-3.3,0-5.9-2.6-6-5.9c0-5.5,0-11,0-16.5c0-3.3,2.6-5.9,6-5.9c5.6,0,11.3,0,16.9,0 c3.4,0,6,2.6,6,6C85.5,76.6,85.5,82.1,85.5,87.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.2,33.9c1.4,5.2-0.2,9.9-4.1,12.6c-6.2,4.4-15.2,0.5-16.2-7c-0.1-0.5-0.1-1-0.2-1.5c-0.2-1.1-1.1-1.9-2.2-1.9 c-1,0-2,0-3,0c-1.6,0-2.5,0.8-2.7,2.4c-0.6,4.3-2.7,7.5-6.8,9.2c-5.7,2.3-12.4-1.3-13.8-7.5c-0.1-0.3-0.2-0.7-0.2-1 c-0.4-2.7-0.8-3-3.5-3c-0.5,0-1,0-1.4,0c-2.4-0.2-3,1.2-3.2,2.9c-0.5,3.8-2.4,6.5-5.8,8.3c-6.3,3.3-14.2-1.1-14.9-8.2 c-0.2-2.3-1-3-3.4-3c-0.7,0-1.4,0-2,0c-1.6,0-2.6,0.9-2.7,2.5c-0.4,4.7-3.7,8.5-8.1,9.5C5.5,49.8,0.5,43.9,0,38.6 c-0.2-3,0.5-5.8,1.3-8.6c2.6-8.9,5.2-17.9,7.9-26.8C9.9,1,11.5,0,13.9,0h39.8v0.1h39.7c2.8,0,4.3,1.1,5.1,3.8 C101.4,13.9,104.4,23.9,107.2,33.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetail);
export default __webpack_public_path__ + "static/media/retail.b8e5488ffebec3a49e9f54d82dea6d23.svg";
export { ForwardRef as ReactComponent };